import { render, staticRenderFns } from "./liveCenter.vue?vue&type=template&id=fb3923cc"
import script from "./liveCenter.vue?vue&type=script&lang=js"
export * from "./liveCenter.vue?vue&type=script&lang=js"
import style0 from "./liveCenter.vue?vue&type=style&index=0&id=fb3923cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports